<template>
        <div class="modal" v-bind:class="{'is-active': show}">
                <div class="modal-background"></div>
                <div class="modal-card">
                        <header class="modal-card-head">
                                <p class="modal-card-title">Would you like to extend your trial period for an additional 7 days?</p>
                        </header>
                        <section class="modal-card-body">
                                <div class="columns is-multiline">
                                        <div class="column is-12 content">
                                                <p class="has-text-justified">
                                                        Please provide us with a <b><i>short</i></b> review of our application.
                                                        If you did not have enough time to test it, please tell us <b><i>what</i></b> you expect from this app and <b><i>how</i></b> you plan on using it to save that precious time.
                                                        Additionally, please keep it <b><i>concise</i></b> and <b><i>honest</i></b>, the minimum number of characters is <b><i>200</i></b>.
                                                </p>

                                                <textarea  id="content" class="textarea" name="content" v-model="content"  v-validate="'required|min:200'"  v-bind:class="{'input': true, 'is-danger': errors.has('content') }"
                                                          type="text"
                                                          placeholder="I would like to extend my trial period because .....">
                                                </textarea>
                                                <span class="help has-text-grey is-pulled-right">{{ content.length }}/200</span>
                                                <transition name="fade-fast">
                                                        <span v-show="errors.has('content')" class="help is-danger">{{ errors.first('content') }}</span>
                                                </transition>
                                        </div>
                                </div>
                        </section>
                        <footer class="modal-card-foot has-text-right">
                                <button class="button is-primary is-pulled-right" @click="extend">Yes, please!</button>
                                <button class="button is-danger is-pulled-right" @click="closeModal">No, thanks</button>
                        </footer>
                </div>
        </div>
</template>
<script>

    import _ from 'lodash'

    import TicketRepo from '../../repos/TicketRepo'

    export default {
        name: 'TrialExtendModal',
        components: {},
        props:['show'],
        data() {
            return {
                loading: false,
                saving: false,
                content: '',
                repo: new TicketRepo(this.$auth),
            }
        },
        created(){

        },
        mounted(){

        },
        methods: {
            closeModal(){
                this.$emit("onClose", {});
            },
            extend(){
                let self = this;
                this.$validator.validateAll().then((result) => {
                    if (result) {

                        this.repo.extendTrial({content: this.content}).then(response => {
                            this.$toast.success(response.data.message);
                            this.$emit("onTrialExtended", response.data.data);
                        }).finally(() => {
                            self.closeModal();
                        });

                    }
                });
            }
        },
        watch: {}

    }
</script>

<style lang="css" scoped>

        @media screen and (min-width: 769px){

                .modal-card {
                        width: 678px;
                }
        }
</style>



// WEBPACK FOOTER //
// src/components/subscription/TrialExtendModal.vue